import { CustomCurrencyPipe } from '../../../../../_helpers/_pipes/custom-currency.pipe';
import { SortPipe } from '../../../../../_helpers/_pipes/sort.pipe';
import { AcmicCoveragesComponent } from '../acmic-coverages/acmic-coverages.component';
import { CustomTooltipComponent } from '../../billing/custom-tooltip/custom-tooltip.component';
import { DashboardNavComponent } from '../myinsurance-nav/dashboard-nav.component';
import { CarHeaderComponent } from '../myinsurance-headers/car-header/car-header.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, RouterModule } from '@angular/router';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { Constants } from '@models/constants';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PolicyDetailsService } from '@services/my-insurance/policy-details.service';
import { DocumentsDataService } from '@services/data-services/documents-data.service';
import { ErrorRedirectionService } from '@services/error-service/error-redirection.service';
import { CoveragesService } from '@services/coverages.service';
import { SortByDatePipe } from '@helpers/_pipes/sort-by-date.pipe';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule, MapfreLoadingComponent, MapfreCardComponent, CarHeaderComponent, DashboardNavComponent, CustomTooltipComponent, AcmicCoveragesComponent, SortPipe, CustomCurrencyPipe],
  selector: 'app-coverages',
  templateUrl: './coverages.component.html',
  styleUrls: ['./coverages.component.scss'],
  providers: [SortByDatePipe]
})
export class CoveragesComponent implements OnInit, OnDestroy {
  loading = false;
  isAcmic = false;
  policyDetails: any = [];
  policyId: string;
  cindex: number;
  clpindex: string;
  compulsoryCoverages: any = [];
  optionalCoverages: any = [];
  seeDecCoverages: string[] = [
    Constants.COLLISION_LOSS,
    Constants.LIMITTED_COLLISION_LOSS,
    Constants.COMPREHENSIVE_LOSS,
  ];
  coverageTerm: any;
  deductibleTerm: any;
  autoCloseProp = false;
  documentsData: any = [];
  requiredCoverages: any;
  vehicleCoverage: any;
  isTooltipVisible: boolean;
  isOperationalTooltipVisible: boolean;
  constructor(
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private acmicService: AcmicService,
    private policyDetailsService: PolicyDetailsService,
    private documentsDataService: DocumentsDataService,
    private errorRedirectionService: ErrorRedirectionService,
    private elementRef: ElementRef,
    private coveragService: CoveragesService,
    private sortByDatePipe: SortByDatePipe
  ) {
    this.requiredCoverages = [
      "Bodily Injury to Others (Per Person/Accident)",
      "Personal Injury Protection (Per Person)",
      "Bodily Injury Caused by an Uninsured Auto (Per Person/Accident)",
      "Damage to Someone Else's Property (Per Accident)"
    ];
    this.vehicleCoverage = [
      this.coveragService.getBodilyInjuryToOthers(false),
      {
        coverageName: "Personal Injury Protection (per person)",
        displayCovNamePartOne: "Personal Injury Protection",
        displayCovNamePartTwo: "(per person)",
        coverageDescription: `If you, your passengers, or pedestrians are hurt in an accident, whether it was your fault or not, then Personal Injury Protection often called PIP or no-fault coverage, covers qualifying medical expenses, lost wages, and even childcare fees based on your policy limits.`,
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/ma-personal-injury-protection/'
      },
      {
        coverageName: "Bodily Injury Caused by an Uninsured Auto (per person/accident)",
        displayCovNamePartOne: "Bodily Injury Caused by an Uninsured Auto",
        displayCovNamePartTwo: Constants.PER_PERSON_ACCIDENT,
        coverageDescription: `If you are hit by an uninsured driver then Uninsured Motorist Coverage (UM for short) provides financial protection when an at-fault driver doesn't have insurance to cover your damages.`,
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/uninsured-underinsured-motorist-coverage/'
      },
      {
        coverageName: "Damage to Someone Else's Property (per accident)",
        displayCovNamePartOne: "Damage to Someone Else's Property",
        displayCovNamePartTwo: "(per accident)",
        coverageDescription: 'If you damage someone’s car, yard, or house in an accident that is your fault, then Property Damage Coverage pays for qualifying repairs for the property that was damaged, up to your policy limits.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/what-full-coverage-car-insurance-consist/'
      },
      this.coveragService.getBodilyInjuryToOthers(true),
      {
        coverageName: "Medical Payments (per person)",
        displayCovNamePartOne: "Medical Payments",
        displayCovNamePartTwo: "(per person)",
        coverageDescription: `Medical payments coverage, sometimes called MedPay, usually helps pay for expenses related to necessary medical and funeral services for the insured, their family, and their passengers following an accident, regardless of fault.`,
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/medical-payments-coverage/'
      },
      {
        coverageName: "Collision Loss Settlement (ACV, stated)",
        displayCovNamePartOne: "Collision",
        displayCovNamePartTwo: "(loss settlement (ACV, stated))",
        coverageDescription: 'Collision insurance helps cover damage to the insured’s car as a result of a crash. If the car is totaled, collision insurance can help compensate the policyholder for the value of the vehicle.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: Constants.COLLISION_COVERAGE_URL
      },
      {
        coverageName: "Limited Collision Loss Settlement (ACV, stated)",
        displayCovNamePartOne: "Limited Collision",
        displayCovNamePartTwo: "(loss settlement (ACV, stated))",
        coverageDescription: 'In the event of a collision in which your vehicle is damaged, standard collision can be used to repair your vehicle regardless of who is at fault. Limited collision differs in that it can only be used if you are found to be less than 50% at fault in an accident.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: Constants.COLLISION_COVERAGE_URL
      },
      {
        coverageName: "Comprehensive Settlement (ACV, stated, agreed)",
        displayCovNamePartOne: "Comprehensive",
        displayCovNamePartTwo: "(loss settlement (ACV, stated, agreed))",
        coverageDescription: 'This coverage typically ensures that any accidental and direct damage to your auto, other than damage caused by a collision, is covered. It may include damage caused by wind, fire, flood, theft, vandalism, hail, or contact with an animal.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: Constants.COLLISION_COVERAGE_URL
      },
      {
        coverageName: "Substitute Transportation (day/maximum)",
        displayCovNamePartOne: "Substitute Transportation",
        displayCovNamePartTwo: "(day/maximum)",
        coverageDescription: 'Substitute Transportation coverage can help cover the cost of a rental vehicle for the duration of repairs following an accident or while the insured shops for a new car.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/benefits-elite-package-endorsement/'
      },
      {
        coverageName: "Towing and Labor (per disablement)",
        displayCovNamePartOne: "Towing and Labor",
        displayCovNamePartTwo: "(per disablement)",
        coverageDescription: 'Towing and labor coverage can help cover costs up to a specified limit each time the insured car is disabled.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/benefits-elite-package-endorsement/'
      },
      {
        coverageName: "Bodily Injury Caused by an Underinsured Auto (per person/accident)",
        displayCovNamePartOne: "Bodily Injury Caused by an Underinsured Auto",
        displayCovNamePartTwo: Constants.PER_PERSON_ACCIDENT,
        coverageDescription: `If you are hit by an underinsured driver then Underinsured Motorist Coverage (UIM for short) provides financial protection when an at-fault driver doesn't have enough insurance to cover your damages.`,
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/uninsured-underinsured-motorist-coverage/'
      },
      {
        coverageName: "Excess Electronic Equipment",
        displayCovNamePartOne: "Excess Electronic Equipment",
        displayCovNamePartTwo: "",
        coverageDescription: 'Excess Electronic Equipment provides additional coverage for loss or damage to any electronic equipment that reproduces, receives, or transmits audio, visual, or data signals, and which is permanently installed in the auto.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/car-insurance/massachusetts-car-insurance/'
      },
      {
        coverageName: "Auto Loan Lease Coverage",
        displayCovNamePartOne: "Auto Loan Lease Coverage",
        displayCovNamePartTwo: "",
        coverageDescription: 'Gap insurance, or loan/lease coverage, is optional and available if you are the original loan or leaseholder on a vehicle. Should you need to file a claim and your loan amount is more than your vehicle is worth, gap insurance would cover the difference, minus your deductible.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/what-is-gap-insurance/'
      },
      {
        coverageName: "Limited Transportation Coverage",
        displayCovNamePartOne: "Limited Transportation Coverage",
        displayCovNamePartTwo: "",
        coverageDescription: 'Limited Transportation Coverage provides those who drive for a rideshare company (“TNC”) with the opportunity to purchase coverage that applies during the standby period – i.e., while the driver is logged into or is otherwise accessing a TNC platform but has not yet accepted a passenger or a delivery request.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/blog/ease-on-down-the-road-4-insurance-tips-for-uber-lyft-drivers/'
      },
      {
        coverageName: "Motorcycle Accessory Coverage",
        displayCovNamePartOne: "Motorcycle Accessory Coverage",
        displayCovNamePartTwo: "",
        coverageDescription: 'Motorcycle Accessory Coverage may be purchased to protect from physical damage to or loss of accessories, on a motorcycle or motorcycle trailer, other than those that are original manufacturer-installed and which alter the appearance or performance of a motorcycle or motorcycle trailer.',
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/motorcycle-insurance/massachusetts-motorcycle-insurance/'
      },
      {
        coverageName: "Value Endorsement",
        displayCovNamePartOne: "Value Endorsement",
        displayCovNamePartTwo: "",
        coverageDescription: `The Value Endorsement provides policyholders the opportunity to reduce their policy premium while agreeing to accept reduced coverages and mandatory deductible options for both physical damage and personal injury protection.`,
        coveragelink: Constants.LEARN_MORE,
        coverageURL: 'https://www.mapfreinsurance.com/car-insurance/massachusetts-car-insurance/'
      }
    ];
  }



  private getCoverages(coverages, index?): void {
    const reqdCoverages = [];
    const optnlCoverages = [];
    if (coverages) {
      coverages.forEach(cov => {
        if (this.requiredCoverages.includes(cov.coverageName)) {
          reqdCoverages.push(cov);
        } else {
          optnlCoverages.push(cov);
        }
      });
      this.compulsoryCoverages[index] = reqdCoverages;
      this.optionalCoverages[index] = optnlCoverages;
    }
  }
  addOrRemoveClass(titleElement, typeOfClass) {
    if (titleElement && !titleElement.classList.contains(typeOfClass)) {
      titleElement.classList.add(typeOfClass);
    } else {
      titleElement.classList.remove(typeOfClass);
    }
  }
  public toggleCollapse(coverages, index): void {
    this.getCoverages(coverages, index);
    this.cindex = index;
    this.clpindex = 'collapse' + index;
    const titleElement = document.getElementById('title' + index);
    this.addOrRemoveClass(titleElement, 'active');

    const element = document.getElementById('collapse' + index);
    this.addOrRemoveClass(element, 'show');
  }
  toggleCoverageCollapse(indx, index, title, typeOfCollapse) {
    const titleElement = document.getElementById(index + title + indx);
    this.addOrRemoveClass(titleElement, 'active');

    const element = document.getElementById(index + typeOfCollapse + indx);
    this.addOrRemoveClass(element, 'show');
  }
  public requiredCovToggleCollapse(indx, obj, index) {
    this.toggleCoverageCollapse(indx, index, 'coverageTitle', 'coverageCollapse');
  }
  public optinalCovToggleCollapse(indx, obj, index) {
    this.toggleCoverageCollapse(indx, index, 'optinalTitle', 'optinalCollapse');
  }
  public splitCoverageName(coverageName, indx) {
    const currentCoverage = this.vehicleCoverage.find(coverage => coverage.coverageName.toLowerCase() === coverageName.toLowerCase());
    if (currentCoverage) {
      if (indx === 0) {
        return currentCoverage.displayCovNamePartOne;
      } else {
        return currentCoverage.displayCovNamePartTwo;
      }
    }
  }
  public checkForSingleVehicle(vehicle): boolean {
    if (vehicle.length === 1) {
      this.getCoverages(vehicle[0].coverages, 0);
      return true;
    }
    return false;
  }
  isItHaveLimit(terms: any[], type) {
    if (!terms) {
      return;
    }
    this.coverageTerm = {};
    this.coverageTerm = terms.find((term) => term.termModelType === type);
    return this.coverageTerm;
  }
  isItHaveDeductible(terms: any[], type, coverageNage?) {
    if (!terms) {
      return;
    }
    this.deductibleTerm = {};
    this.deductibleTerm = terms.find(
      (term) => term.termModelType === type && term.termName === type
    );
    if (
      this.deductibleTerm &&
      coverageNage === 'Personal Injury Protection (Per Person)'
    ) {
      if (this.deductibleTerm.termAmount.toLowerCase() !== 'full coverage') {
        this.deductibleTerm.termAmount = this.deductibleTerm.termAmount
          .split('/')[0]
          .split(' ')[0];
      }
    }
    return this.deductibleTerm;
  }
  getDocumentsData() {
    this.documentsDataService.$renewalPoliciesDocumentData.subscribe(
      (policiesWithDocs) => {
        if (policiesWithDocs && policiesWithDocs.length > 0) {
          const policyDocuments = policiesWithDocs.find(
            (element) => element.policyNumber === this.policyId
          );
          if (policyDocuments) {
            this.documentsData = policyDocuments;
          }
        }
        if (this.documentsData.length === 0) {
          this.policyDetailsService
            .getDocumentsByPolicy(this.policyId)
            .subscribe(
              (documentResponse) => {
                this.documentsData = documentResponse;
              },
              (err) => {
                this.errorRedirectionService.errorRedirectHandler(
                  err,
                  this.policyId
                );
              }
            );
        }
      }
    );
  }
  addCustomLoaderClass(docLinkIndex) {
    const ele = this.elementRef.nativeElement.querySelector(`.see-dec-selector-${docLinkIndex}`);
    if (ele) {
      ele.classList.add('custom_loader');
    }
  }
  removeCustomLoaderClass(docLinkIndex) {
    const ele = this.elementRef.nativeElement.querySelector(`.see-dec-selector-${docLinkIndex}.custom_loader`);
    if (ele) {
      ele.classList.remove('custom_loader');
    }
  }
  public openPolicyDocuments(event: Event, index, vehicleIndex) {
    const docLinkIndex = `${vehicleIndex}${index}`;
    this.addCustomLoaderClass(docLinkIndex)
    event.preventDefault();
    event.stopPropagation();
    const docToBeOppenned = this.sortByDatePipe.transform(this.documentsData.filter(doc => ['NEWBUS', 'ENDORSE', 'RENEWAL'].includes(doc.type)), '-transactionDate')[0];
    if (docToBeOppenned) {
      this.documentsDataService.viewDocument(docToBeOppenned.documentId, this.policyId, docToBeOppenned.documentType, docToBeOppenned.date, docToBeOppenned.description, docLinkIndex);
    }
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });
    this.getDocumentsData();
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policyDetails = policyResponse;
        this.loading = false;
      }
    });
    this.documentsDataService.getCustomLoader().subscribe(indexToHideLoader => {
      if (indexToHideLoader !== '') {
        this.removeCustomLoaderClass(indexToHideLoader);
      }
    })
  }
  onTolltipHover() {
    this.isTooltipVisible = true;
  }

  showToolTip(event) {
    this.isTooltipVisible = event;
  }

  onOperationalTolltipHover() {
    this.isOperationalTooltipVisible = true;
  }

  showOperationalToolTip(event) {
    this.isOperationalTooltipVisible = event;
  }
  ngOnDestroy(): void {
    this.documentsDataService.setCustomLoader('');
  }
}
